import SEO from "@/components/SEO";

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <SEO
        title="Terms and Conditions"
        description="Terms and Conditions governing your use of the Asian Picks website and Asian Handicap tipping subscription services."
        path="/terms"
      />
      <section className="bg-ink-950 text-white py-16 sm:py-20 relative overflow-hidden">
        <div className="absolute -top-20 -right-20 w-[400px] h-[400px] rounded-full bg-emerald-700/25 blur-[120px]" />
        <div className="absolute -bottom-20 -left-20 w-[400px] h-[400px] rounded-full bg-gold-500/15 blur-[120px]" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-gold-400 font-mono uppercase tracking-widest text-xs mb-3">
            Legal
          </div>
          <h1
            data-testid="terms-title"
            className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight max-w-3xl"
          >
            Terms and <span className="gold-text">Conditions</span>
          </h1>
          <p className="mt-5 max-w-2xl text-white/70 text-base sm:text-lg leading-relaxed">
            These terms govern your access to and use of the Asian Picks
            website and subscription services. By using this site, you agree
            to be bound by them.
          </p>
        </div>
      </section>

      <section className="py-16 sm:py-24 bg-ink-50">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10 text-ink-700 leading-relaxed">
          <div>
            <h2 className="font-display font-bold text-2xl text-ink-900 mb-3">
              1. Acceptance of terms
            </h2>
            <p>
              By accessing asian-picks.com or subscribing to any of our
              services, you confirm that you are at least 18 years of age (or
              the legal gambling age in your jurisdiction, whichever is
              higher), that you have read and understood these Terms and
              Conditions, and that you agree to comply with them in full. If
              you do not agree, please do not use this website.
            </p>
          </div>

          <div>
            <h2 className="font-display font-bold text-2xl text-ink-900 mb-3">
              2. Nature of the service
            </h2>
            <p>
              Asian Picks provides an information and analysis service focused
              on the Asian Handicap football betting market. We publish
              historical results, tipping analysis, and — to paying subscribers
              — a fixed number of Asian Handicap selections delivered by
              email. We are not a bookmaker, do not accept wagers, and do not
              hold or transmit any funds on behalf of users.
            </p>
          </div>

          <div>
            <h2 className="font-display font-bold text-2xl text-ink-900 mb-3">
              3. Subscription packages
            </h2>
            <p>
              Our subscription packages are sold on a fixed-volume basis (for
              example: 15, 30 or 50 Asian Handicap tips). Each package is a
              one-time purchase — it is not a recurring subscription. Once the
              agreed number of tips has been delivered and settled, the
              package is complete. The number of calendar days a package spans
              will vary with fixture density and available betting value.
            </p>
          </div>

          <div>
            <h2 className="font-display font-bold text-2xl text-ink-900 mb-3">
              4. Payment
            </h2>
            <p>
              We do not process payments on this website. To subscribe, you
              must contact us via email or the Contact page. Once contact is
              initiated, we will share the payment details for your selected
              method (e-wallet, cryptocurrency, bank transfer, etc.).
              Subscription is activated only after cleared payment is
              confirmed by us.
            </p>
          </div>

          <div>
            <h2 className="font-display font-bold text-2xl text-ink-900 mb-3">
              5. Refunds
            </h2>
            <p>
              Given the nature of our service — the delivery of information
              that cannot be "returned" — all payments to Asian Picks are
              final and non-refundable once tips have started to be delivered.
              We do not offer refunds, credits or free replacement picks for
              tips that lose. Any exception is at our sole discretion and does
              not create a precedent.
            </p>
          </div>

          <div>
            <h2 className="font-display font-bold text-2xl text-ink-900 mb-3">
              6. Delivery and access
            </h2>
            <p>
              Tips are delivered by email to the address you provide when you
              subscribe. It is your responsibility to keep that email address
              active and to check it (including spam folders) regularly.
              Asian Picks is not liable for undelivered or unread tips caused
              by an invalid email address, a full inbox, or filtering by your
              email provider.
            </p>
          </div>

          <div>
            <h2 className="font-display font-bold text-2xl text-ink-900 mb-3">
              7. Intellectual property
            </h2>
            <p>
              All content on this website — including text, graphics, logos,
              tips, analysis and the underlying selection methodology — is the
              intellectual property of Asian Picks and is protected by
              applicable copyright and trademark laws. You may not copy,
              reproduce, redistribute, resell or republish any part of the
              website or subscription content without our prior written
              consent.
            </p>
          </div>

          <div>
            <h2 className="font-display font-bold text-2xl text-ink-900 mb-3">
              8. Account sharing
            </h2>
            <p>
              Subscriptions are for individual, personal use only. Sharing
              tips with third parties, forwarding subscription emails, posting
              picks to social channels or reselling access is strictly
              prohibited and will result in immediate termination of the
              subscription without refund.
            </p>
          </div>

          <div>
            <h2 className="font-display font-bold text-2xl text-ink-900 mb-3">
              9. Prohibited use
            </h2>
            <p>
              You agree not to use the website in any way that is unlawful,
              fraudulent or harmful, or that infringes the rights of any third
              party. You further agree not to attempt to gain unauthorised
              access to any part of the website, its servers or any connected
              database.
            </p>
          </div>

          <div>
            <h2 className="font-display font-bold text-2xl text-ink-900 mb-3">
              10. Limitation of liability
            </h2>
            <p>
              To the fullest extent permitted by law, Asian Picks accepts no
              liability for any losses — financial or otherwise — arising from
              your use of the website, reliance on any tip, or interaction
              with any third-party bookmaker or payment provider. Sports
              betting is inherently risky; you assume all risk.
            </p>
          </div>

          <div>
            <h2 className="font-display font-bold text-2xl text-ink-900 mb-3">
              11. Termination
            </h2>
            <p>
              We reserve the right to suspend or terminate access to the
              website or any active subscription, without refund, if we
              reasonably believe you have breached these Terms and Conditions
              or applicable law, or if you show signs of problem gambling.
            </p>
          </div>

          <div>
            <h2 className="font-display font-bold text-2xl text-ink-900 mb-3">
              12. Governing law
            </h2>
            <p>
              These Terms and Conditions are governed by the laws applicable
              in the jurisdiction of the website operator. Any dispute arising
              out of or in connection with them shall be subject to the
              exclusive jurisdiction of the competent courts of that
              jurisdiction.
            </p>
          </div>

          <div>
            <h2 className="font-display font-bold text-2xl text-ink-900 mb-3">
              13. Changes to these terms
            </h2>
            <p>
              We may update these Terms and Conditions from time to time. The
              revised version will be posted on this page with a new effective
              date. Continued use of the website after publication of an
              updated version constitutes acceptance of that version.
            </p>
          </div>

          <p className="text-xs text-ink-500 font-mono pt-6 border-t border-ink-200">
            Last updated: 2023.
          </p>
        </div>
      </section>
    </div>
  );
}
